import { createSlice } from '@reduxjs/toolkit'

import {
  connectIntegrationByToken,
  disconnectIntegration,
} from 'common/actions/integrations/common/actions/integrationActions'

export interface HotmartIntegrationState {
  isConnecting: boolean
  isDisconnecting: boolean
  showConnectionModal: boolean
}

const initialState: HotmartIntegrationState = {
  isConnecting: false,
  isDisconnecting: false,
  showConnectionModal: false,
}

export const { reducer: hotmartReducer, actions: hotmartIntegrationActions } = createSlice({
  name: 'hotmart',
  initialState,
  reducers: {
    showModal: (state) => {
      state.showConnectionModal = true
    },
    hideModal: (state) => {
      state.showConnectionModal = false
    },
  },
  extraReducers: (builder) => {
    builder.addCase(connectIntegrationByToken.pending, (state) => {
      state.isConnecting = true
    })
    builder.addCase(connectIntegrationByToken.rejected, (state) => {
      state.isConnecting = false
    })
    builder.addCase(connectIntegrationByToken.fulfilled, (state) => {
      state.isConnecting = false
    })
    builder.addCase(disconnectIntegration.pending, (state) => {
      state.isConnecting = true
    })
    builder.addCase(disconnectIntegration.fulfilled, (state) => {
      state.isConnecting = false
    })
  },
})

export const hotmartSelectors = {
  getIntegrationData: (state: RootState) => state.integrations.hotmart,
}
